(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    },
    { once: true }
  );
}

// Track if we've created the dropdown
let sortDropdownCreated = false;

// Move CloudSearch sort filter above the product grid and convert to dropdown
function moveSortDropdown() {
  const sortContainer = document.getElementById('cloud_search_sort_dropdown');
  
  if (!sortContainer) return false;
  
  // Find all sort filters on the page (excluding ones we've hidden)
  const allSortFilters = document.querySelectorAll('[data-filter-name="Sort by"]');
  
  if (allSortFilters.length === 0) return false;
  
  // Get the first visible sort filter to extract current selection
  let sortFilter = null;
  for (const filter of allSortFilters) {
    if (!sortContainer.contains(filter)) {
      sortFilter = filter;
      break;
    }
  }
  
  if (!sortFilter) return false;
  
  // Extract sort data
  const sortData = extractSortData(sortFilter);
  
  if (sortData.length === 0) return false;
  
  // Check if dropdown already exists
  const existingSelect = sortContainer.querySelector('.sort-dropdown-select');
  
  if (existingSelect) {
    // Update the selected value instead of recreating
    const selectedItem = sortData.find(item => item.isSelected);
    if (selectedItem) {
      existingSelect.value = selectedItem.value;
    }
  } else {
    // Create our own dropdown
    createSortDropdown(sortContainer, sortData, sortFilter);
  }
  
  // Hide all original sort filters
  allSortFilters.forEach(filter => {
    filter.style.display = 'none';
  });
  
  sortDropdownCreated = true;
  
  return true;
}

function extractSortData(sortFilter) {
  const labels = sortFilter.querySelectorAll('.cloud-search-filter-value');
  const sortData = [];
  
  labels.forEach(label => {
    const value = label.getAttribute('data-filter-value');
    const nameEl = label.querySelector('.cloud-search-filter-value__name');
    const name = nameEl ? nameEl.textContent : value;
    const isSelected = label.classList.contains('cloud-search-filter-value--selected');
    
    sortData.push({ value, name, isSelected });
  });
  
  return sortData;
}

function createSortDropdown(container, sortData, originalFilter) {
  // Clear container
  container.innerHTML = '';
  
  // Create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'sort-dropdown-wrapper';
  
  // Create label
  const label = document.createElement('span');
  label.className = 'sort-dropdown-label';
  label.textContent = 'Sort by:';
  
  // Create select element
  const select = document.createElement('select');
  select.className = 'sort-dropdown-select';
  
  // Create options
  sortData.forEach(item => {
    const option = document.createElement('option');
    option.value = item.value;
    option.textContent = item.name;
    if (item.isSelected) {
      option.selected = true;
    }
    select.appendChild(option);
  });
  
  // Handle change event - click the corresponding radio button in the original filter
  select.addEventListener('change', (e) => {
    const selectedValue = e.target.value;
    
    // Find and click the radio in any of the original sort filters
    const allSortFilters = document.querySelectorAll('[data-filter-name="Sort by"]');
    for (const filter of allSortFilters) {
      const targetLabel = filter.querySelector(`[data-filter-value="${selectedValue}"]`);
      if (targetLabel) {
        const radio = targetLabel.querySelector('input[type="radio"]');
        if (radio) {
          radio.click();
          break;
        }
      }
    }
  });
  
  wrapper.appendChild(label);
  wrapper.appendChild(select);
  container.appendChild(wrapper);
}

// Position sort dropdown for mobile - move into filters row
function positionMobileSortDropdown() {
  const sortContainer = document.getElementById('cloud_search_sort_dropdown');
  const mobileFiltersContainer = document.querySelector('.cloud-search-page-controls__filters-container');
  
  if (!sortContainer) return;
  
  const isMobile = window.innerWidth < 768;
  
  if (isMobile && mobileFiltersContainer) {
    // Move sort container into the mobile filters row if not already there
    if (!mobileFiltersContainer.contains(sortContainer)) {
      mobileFiltersContainer.appendChild(sortContainer);
    }
  } else {
    // Move back to original position on desktop
    const desktopContainer = document.querySelector('.collection-sort-container');
    if (desktopContainer && !desktopContainer.contains(sortContainer)) {
      desktopContainer.appendChild(sortContainer);
    }
  }
}

// Ensure sort dropdown is visible
function ensureSortDropdownVisible() {
  const sortContainer = document.getElementById('cloud_search_sort_dropdown');
  if (sortContainer) {
    sortContainer.style.display = 'flex';
  }
}

// Run when DOM is ready and observe for dynamic changes
document.addEventListener('DOMContentLoaded', () => {
  // Initial setup
  setTimeout(() => {
    moveSortDropdown();
    positionMobileSortDropdown();
    ensureSortDropdownVisible();
  }, 100);
  
  // Reposition on resize
  window.addEventListener('resize', positionMobileSortDropdown);
  
  // Create a single observer function
  const handleMutations = () => {
    moveSortDropdown();
    hideOriginalSortFilters();
    positionMobileSortDropdown();
    ensureSortDropdownVisible();
  };
  
  // Observe the entire cloud search area for changes
  const cloudSearchRoot = document.getElementById('cloud_search_filters_root');
  const cloudSearchSidebar = document.getElementById('cloud_search_filters_sidebar');
  const mainContent = document.querySelector('.cloud-search-filters-products');
  
  const observerConfig = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  };
  
  if (cloudSearchRoot) {
    const observer = new MutationObserver(handleMutations);
    observer.observe(cloudSearchRoot, observerConfig);
  }
  
  if (cloudSearchSidebar) {
    const observer = new MutationObserver(handleMutations);
    observer.observe(cloudSearchSidebar, observerConfig);
  }
  
  if (mainContent) {
    const observer = new MutationObserver(handleMutations);
    observer.observe(mainContent, observerConfig);
  }
  
  // Also listen for CloudSearch custom events if they exist
  document.addEventListener('cloudsearch:updated', handleMutations);
  document.addEventListener('cloudsearch:results', handleMutations);
  
  // Fallback: periodically check if dropdown needs to be recreated
  setInterval(() => {
    const sortContainer = document.getElementById('cloud_search_sort_dropdown');
    const hasDropdown = sortContainer && sortContainer.querySelector('.sort-dropdown-select');
    const hasSortFilters = document.querySelectorAll('[data-filter-name="Sort by"]').length > 0;
    
    if (!hasDropdown && hasSortFilters) {
      handleMutations();
    }
  }, 500);
});

function hideOriginalSortFilters() {
  const sortContainer = document.getElementById('cloud_search_sort_dropdown');
  const allSortFilters = document.querySelectorAll('[data-filter-name="Sort by"]');
  
  allSortFilters.forEach(filter => {
    // Don't hide if it's inside our container
    if (sortContainer && sortContainer.contains(filter)) return;
    filter.style.display = 'none';
  });
}

  } catch(e) { console.error(e); }
})();
})();
